import { Route, Routes } from "react-router-dom";

import { FeatureFlagsProvider } from "@av/apps/common-apps/platform/components/FeatureFlagsProvider";
import { useJobRouteConfig } from "@av/apps/recruitment/ats-common/routes/jobs/jobs.route-config";
import { ForbiddenErrorPage } from "@av/components/templates/layouts/errors/types/ForbiddenErrorPage";
import { PublicNotFoundPage } from "../components/errors/PublicNotFoundPage";
import { JobsAppLayout } from "../components/layout/JobsAppLayout";
import { useLocaleSearchParam } from "../hooks/useLocaleSearchParam";
import { JobApplicationPage } from "../pages/jobs/apply/JobApplicationPage";
import { JobsPage } from "../pages/jobs/JobsPage";

export function JobsAppRoutes() {
  const jobsRoutes = useJobRouteConfig();

  useLocaleSearchParam();

  return (
    <Routes>
      <Route path={jobsRoutes.home.path({ isRelative: true })} element={<JobsAppLayout />}>
        <Route
          path={jobsRoutes.forbidden.path({ isRelative: true })}
          element={<ForbiddenErrorPage />}
        />
        <Route
          path={jobsRoutes.notFound.path({ isRelative: true })}
          element={<PublicNotFoundPage />}
        />

        <Route
          path={jobsRoutes.home.path({
            isRelative: true,
            pathParam: ":companyId",
          })}
          element={<JobsPage />}
        />
        <Route
          path={jobsRoutes.home.view.path({
            isRelative: true,
            pathParam: [":companyId", ":jobPostId"],
          })}
          element={<JobsPage />}
        />

        <Route
          path={jobsRoutes.home.apply.path({
            isRelative: true,
            pathParam: [":companyId", ":jobPostId"],
          })}
          element={
            <FeatureFlagsProvider>
              <JobApplicationPage />
            </FeatureFlagsProvider>
          }
        />
        <Route path="*" element={<PublicNotFoundPage />} />
      </Route>
      <Route path="*" element={<PublicNotFoundPage />} />
    </Routes>
  );
}
